<template>
	<div class="index">
		<h1>Account System Login Demo</h1>
		<h2>App Info</h2>
		<p>Zone: {{ zone }}</p>
		<p v-if="errMsg"> {{ errMsg }} </p>
		<template v-if="isLogin">
			<h2>Hello {{ display_name }}.</h2>
			<p> id: {{ userid }}</p>
			<p> name: {{ display_name }}</p>
			<p> username: {{ username }}</p>
			<p> main account id: {{ main_account_id }}</p>
			<p> language: {{ language }}</p>
			<p> country: {{ country }}</p>
			<p> timezone: {{ timezone }}</p>
			<p> GDPR: {{ gdpr }}</p>
			<p> account type: {{ account_type }}</p>
			<p> tenant: {{ tenant }}</p>
			<p> issuer_zone: {{ issuer_zone }}</p>
			<br>
			<v-btn v-on:click.native="logout">Sign out</v-btn>
			<br>
			<br>
			<v-btn v-on:click.native="testpost">Test Post</v-btn>
			<br>
			<br>
			<v-btn v-on:click.native="testquery">Test Get with query</v-btn>
		</template>
		<template v-else>
			<br>
			<v-btn v-on:click.native="login">Sign in</v-btn>
		</template>
	</div>
</template>

<script>
import LoginManager from '@synology-hct/syno-c2-account-js-sdk'

export default {
	name: 'Index',
	data() {
		return {
			errMsg: "App Info",
			isLogin: false,
			username: "",
			display_name: null,
			tenant: null,
			issuer_zone: null,
			userid: null,
			main_account_id: null,
			language: "",
			timezone: "",
			country: "",
			gdpr: false,
			account_type: null,
			zone: config.ZONE,
			loginManagerHost: config.LOGIN_MANAGER_HOST,
			iframeHost: config.IFRAME_HOST,
			apiBasePath: config.API_BASE_PATH
		}
    },
	async mounted() {
		if (config.DEBUG) {
			// print runtime variables
			for (const key in config) { 
				console.log(key+":",config[key])
			}
		}
		// overwrite url for getting query params since vue-router hash mode treat redirect_URL with query params as search
		// reference: https://github.com/vuejs/vue-router/issues/2125#issuecomment-519521424
		if (location.search) {
			location.replace(location.pathname + location.hash + location.search)
		}
		if (this.$route.query.error) {
			this.errMsg = this.$route.query.error
			if (this.$route.query.error_description) {
				this.errMsg += ": " + this.$route.query.error_description
			}
			if (this.$route.query.error_uri) {
				this.errMsg += ": " + this.$route.query.error_uri
			}
		}

		await LoginManager.configure({ 
			zone: this.zone,
			host: this.loginManagerHost, 
			basePath: `https://${this.loginManagerHost}/${this.apiBasePath}`,
			iframeHost: this.iframeHost
		})
		if (config.DEBUG) {
			console.log("LoginManager configure completed")
		}

		/* eslint-disable */
		let uri = window.location.search.substring(1)
		let params = new URLSearchParams(uri)
		if (window.location.pathname === "/login") {
			this.$router.push({
				name: "Callback"
			})
		} else if (window.location.pathname === "/loginform") {
			this.$router.push({
				name: "Loginform"
			})
		} else {
			this.userApi()
		}
	},
	methods: {
		userApi: async function() {
			const user = await this.getUser()

			if (user) {
				this.isLogin = true;
				this.display_name = user.name
				this.username = user.username
				this.userid = user.id
				this.main_account_id = user.main_account_id
				this.account_type = user.account_type
				this.tenant = user.tenant
				this.issuer_zone = user.issuer_zone
				this.language = user.language
				this.country = user.country
				this.timezone= user.timezone
				this.gdpr = user.gdpr
			}
		},
		getUser: async function() {
			const resp = await LoginManager.sendRequest('/v1/user')

			if (200 === resp.status) {
				return await resp.json()
			}

			return null
		},
		login: async function() {
			await LoginManager.login({redirect_url: window.location.origin, state: "teststate"})
		},
		logout: async function() {
			await LoginManager.logout({redirect_url: window.location.origin})
		},
		testpost: async function() {
			const resp = await LoginManager.sendRequest('/v1/testpost', {
				method: 'POST',
				body: JSON.stringify({
					b1: 123,
					b2: false,
					b3: {
						b4: 'fuck',
					},
				}),
			})

			if (200 === resp.status) {
				console.log(await resp.json())
			}
		},
		testquery: async function() {
			const resp = await LoginManager.sendRequest('/v1/user?q=123')

			if (200 === resp.status) {
				console.log(await resp.json())
			}
		},
	}
}
</script>
